module.exports = __webpack_public_path__ + "static/gavilanwork3-f4996da47e5eaa877ed1c925763a5a84.jpg";